const toc = document.querySelector(".blog-toc__list");

export function generateTableAndIds() {
  let content = document.querySelector(".blog__content");
  const videoPage = document.querySelector(".video-page__content");
  if (!content && videoPage) {
    content = videoPage;
  }
  const headings = content.querySelectorAll("h2");
  const manualToc = document.querySelector("#manual-toc");

  console.log(headings);
  headings.forEach((heading) => {
    const slugified = slugify(heading.innerText);
    heading.setAttribute("id", slugified);
    const list = toc.querySelector("ol");
    if (!manualToc) {
      list.insertAdjacentHTML(
        "beforeend",
        '<li><a href="#' + slugified + '">' + heading.innerText + "</a></li>"
      );
    }
  });
}

export function toggleTable() {
  if (toc.classList.contains("blog-toc__list--open")) {
    closeTable();
  } else {
    openTable();
  }
}

export function setInitialTableHeight() {
  toc.style.maxHeight = toc.scrollHeight + "px";
}

function openTable() {
  toc.classList.add("blog-toc__list--open");
  toc.style.maxHeight = toc.scrollHeight + "px";
}

function closeTable() {
  toc.classList.remove("blog-toc__list--open");
  toc.removeAttribute("style");
}

function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, ""); // trim leading/trailing white space
  str = str.toLowerCase(); // convert string to lowercase
  str = str
    .replace(/[^a-z0-9 -]/g, "") // remove any non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // remove consecutive hyphens
  return str;
}
